import { getCurrencyFromServer } from "logic/services/currency/server";
import { actionController } from "../utils";

export const currencyController = {
  getCoinInfos: (option?: {
    currencyIds?: number[];
    originNetworkId?: number;
    originMicroChainIds?: number[];
    originOwnerId?: number;
    type?: number[];
    mainStatus?: number[];
    subStatus?: number[];
  }) => {
    return actionController(async () => {
      try {
        const currency = await getCurrencyFromServer({
          query: {
            ...(option?.currencyIds && { currencyIds: option.currencyIds }),
            ...(option?.originNetworkId && {
              originNetworkId: option.originNetworkId,
            }),
            ...(option?.originMicroChainIds && {
              originMicroChainIds: option.originMicroChainIds,
            }),
            ...(option?.originOwnerId && {
              originOwnerId: option.originOwnerId,
            }),
            ...(option?.type && { type: option.type }),
            ...(option?.mainStatus && { mainStatus: option.mainStatus }),
            ...(option?.subStatus && { subStatus: option.subStatus }),
          },
        });

        return currency;
      } catch (e) {
        throw new Error("Failed_to_get_coin_info");
      }
    });
  },
};
